import React from "react"
import PropTypes from "prop-types"

// Components
import GlobalStyle from "../components/style"
import MainWrapper from "../components/mainwrapper"
import Navigation from "../components/navigation"


const Layout = (props) => {
  return (
    <>
      <script>{`
        (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:5159917,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `}
      </script>
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-N2K0HW3V4S"></script>
      <script>{`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-N2K0HW3V4S');
      `}
      </script>
      <GlobalStyle />
      <MainWrapper>
        <Navigation />
        {props.children}
      </MainWrapper>
    </>
  )
}

Layout.propTypes = {
  pageContext: PropTypes.object,
  children: PropTypes.array,
}

export default Layout
